<template >
  <div >
    <el-row >
      <el-col :sm="6" >
        <el-button
            @click="getLog()"
            type="primary" >{{ $t('Ιστορικό') }}
        </el-button >
      </el-col >
      <el-col
          v-for="mrk in selectedInvoice.aade_marks"
          :sm="6"
          style="overflow: hidden" >

        <el-button @click="checkMark(mrk)" >{{ mrk }}</el-button >
      </el-col >
    </el-row >
    <el-row >

      <s-button
          type="danger"
          v-if="!!selectedInvoice.aade_uid"
          :confirm="$t('Αυτή η ενέργεια θα ξεκλειδώσει το παραστατικό για να μπορέσετε να το διορθώσετε και να το ξαναστείλετε στην ΑΑΔΕ. Αυτά δεν είναι και πολύ σωστά πράγματα καλύτερα να μιλήσετε με τον λογιστή σας πρώτα. Θέλετε να προχωρήσω;')"
          @execute="clearInvoice" >Ξεκλείδωσε το παραστατικό για επιπλέον επεξεργασία
      </s-button >
    </el-row >
    <el-card
        v-if="logData"
        v-fill-height >
      <pre >{{ logData }}</pre >
    </el-card >
    <el-card v-if="selectedMark" >
      <el-row
          slot="header"
          class="clearfix"
          :gutter="5" >
        <el-button
            @click="aadeReport=null;selectedMark=null"
            icon="el-icon-close"
            style="float: right" ></el-button >
        <!--        <el-input v-model="selectedMark" ></el-input >-->
        <!--        <el-button-->
        <!--            @click="checkMark(selectedMark)"-->
        <!--            style="float: left" >Φορτωση ({{ selectedMark }})-->
        <!--        </el-button >-->
        <s-button
            confirm="Αυτή η ενέργεια θα ακυρώση αυτη την εγγραφή"
            @execute="cancelAadeMark()"
            type="danger"
            icon="el-icon-document-delete"
            style="float: left" >ΑΚΥΡΩΣΗ ({{ selectedMark }})
        </s-button >
      </el-row >
      <el-row
          :span="24"
          v-if="aadeReport&&aadeReport.nextPartitionKey" >

        <el-button @click="checkMark(selectedMark,{nextPartitionKey:aadeReport.nextPartitionKey,nextRowKey:aadeReport.nextRowKey})" >
          next after {{ aadeReport.total }}
        </el-button >
      </el-row >
      <el-row v-if="aadeReport&&aadeReport.this_invoice" >
        <h3 >This invoice</h3 >
        <pre >{{ aadeReport.this_invoice }}</pre >

      </el-row >
      <el-row v-if="aadeReport&&aadeReport.errors" >
        <h3 v-if="aadeReport.errors_count" >Errors</h3 >
        <el-row
            v-for="(aadeReportErrorGroup,errorType) in aadeReport.errors"
            :key="errorType" >
          <h4 >{{ errorType }}</h4 >
          <el-row
              v-for="(invoicesByClass,invClass) in aadeReportErrorGroup"
              style="padding-left: 10px"
              :key="invClass" >
            <h4 >--{{ invClass }}</h4 >
            <el-row
                v-for="(siraInvoices,invSira) in invoicesByClass"
                style="padding-left: 20px"
                :key="invSira" >
              <h4 >----{{ invSira }}</h4 >
              <el-row
                  v-for="(invMarks,invAA) in siraInvoices"
                  style="padding-left: 25px"
                  :key="invAA" >
                <h4 >{{ invAA }}</h4 >
                <el-row
                    v-for="(invData,invMark) in invMarks"
                    style="padding-left: 25px"
                    :key="invMark" >
                  <el-button
                      @click="cancelAadeMark(invMark,[errorType,invClass,invSira,invAA,invMark])"
                      icon="el-icon-document-delete"
                      type="danger" >{{ invMark }}
                  </el-button >
                  <pre >{{ invData }}</pre >
                </el-row >
              </el-row >
            </el-row >
          </el-row >
        </el-row >
        <!--              {{ aadeReport }}-->
      </el-row >
      <!--            <textarea-->
      <!--                style="width: 100%;background-color: #1b5e20"-->
      <!--                rows="20"-->
      <!--                v-model="aadeReport"-->
      <!--            ></textarea >-->
    </el-card >
  </div >
</template >
<script >
import SButton from "../../Form/SButton"
import _ from "lodash";
import format from "date-fns/format";
import * as api from "~/api/resource";

export default {
  name: 'AADEHandler',
  components: {SButton},
  data() {
    return {
      logData: null,
      selectedMark: null,
      aadeReport: null,
    }
  },
  props: {


    // checkMark: {},
    selectedInvoice: {},

  },
  methods: {
    async clearInvoice() {
      const data = await api.updateProcessor("timologio/update", {
        timologioId: this.selectedInvoice.timologioId,
        aade_uid: null
      });
    },
    async cancelAadeMark(theMark, invDataPath) {//invDataPath=[errorType,invClass,invSira,invMark,invAA]

      // _log_('mark resp:', this.aadeReport, invDataPath)
      const {data} = await api.fetchProcessor("timologio/massissue", {
        do: 'cancelByMark',
        timologioId: this.selectedInvoice.timologioId,
        mark: theMark ? theMark : this.selectedMark
      });

      if (data.results && data.results.aade.results[0].cancellationMark)
        if (invDataPath) this.$set(this.aadeReport.errors[invDataPath[0]][invDataPath[1]][invDataPath[2]][invDataPath[3]][invDataPath[4]], 'CancellationMark', data.results.aade.results[0].cancellationMark)

    },
    async getLog() {
      this.logData = null;
      this.aadeReport = null;
      this.selectedMark = null;
      const {data} = await api.fetchProcessor("actionlog/getlist", {
        classes: 'Timologio,_AADE',
        limit: 0,
        relid: this.selectedInvoice.timologioId,

      });
      this.logData = data.results
    },
    async checkMark(mrk, extras = {}) {
      this.logData = null;
      this.selectedMark = mrk
      this.aadeReport = null
      // this.loaded=false
      const {data} = await api.fetchProcessor("timologio/massissue", {
        do: 'check',
        mark: mrk, ...extras
      });
      if (data.results && data.results.aade)
        this.aadeReport = data.results.aade

      _log_('mark resp:', data)
    },
  }
}
</script >
<style >

div.stamp * {
  padding: 2px;
  /*color: #095b69 !important;*/
  /*background-color: wheat !important;*/
}

/* .actions_btns .fa-cog {
  color: #ffffff;
} */
@media screen and (max-width: 1200px) {

}

@media screen and (max-width: 769px) {
  .responsive-items button {
    margin-left: 0px !important;
    margin-right: 5px;
    margin-bottom: 5px;
  }

}
</style >
